import { PaywallAuthErrorCodes, PaywallPlans, SiteLinks } from "../../../../../global/paywall/paywallInterfaces";
import { PremiumPaywallState } from "../premiumPaywallMobile";
import { is } from "immutable"
import { PremiumPaywallSigninEmailNewspaper } from "../../desktop/signin/premiumPaywallDesktopSigninEmail";
import { getNewlinkTargetProperties } from "../../../ynet1280/ynetShops/data/ynetshopsData";

interface PremiumPaywallMobileSigninEmailProps {
  email: string
  setEmail: (email: string) => void
  setMode: (state: PremiumPaywallState) => void
  loginWithGoogle: () => void
  loginWithApple: () => void
  sendMail: () => void
  authError: string
  isNewspaper?: boolean;
}


declare const window: Window & {
  PAYWALL_PLANS: PaywallPlans
  PAYWALL_SITE_LINKS: SiteLinks;
}

export const PremiumPaywallMobileSigninEmail = (props: PremiumPaywallMobileSigninEmailProps) => {

  const { email, setEmail, loginWithApple, loginWithGoogle, setMode, sendMail, authError, isNewspaper } = props

  const handleMailChange = (e) => {
    setEmail(e.target.value)
  }

  const handleSendMail = () => {
    sendMail()
  }
  const contactUrl = typeof window !== "undefined" && window.PAYWALL_SITE_LINKS ? window.PAYWALL_SITE_LINKS.contact : '';
  const termsUrl = typeof window !== "undefined" && window.PAYWALL_SITE_LINKS ? window.PAYWALL_SITE_LINKS.terms : '';
  const privacyUrl = typeof window !== "undefined" && window.PAYWALL_SITE_LINKS ? window.PAYWALL_SITE_LINKS.privacy : '';
  const targetLink = getNewlinkTargetProperties();


  const errorMessagesFront: Partial<Record<PaywallAuthErrorCodes, string>> = {
    [PaywallAuthErrorCodes.INVALID_EMAIL]: "כתובת המייל אינה תקינה",
  };

  const errorMessagesServer: Partial<Record<PaywallAuthErrorCodes, string>> = {
    [PaywallAuthErrorCodes.FAILED_TO_SEND_OTP]: "אירעה שגיאה במערכת, אנא נסו שוב מאוחר יותר",
    [PaywallAuthErrorCodes.NOT_REGISTERED]: "כתובת המייל איננה רשומה במערכת, יש לעבור להרשמה",
    [PaywallAuthErrorCodes.OTP_MAX_ATTEMPTS]: "חרגת ממספר בקשות אימות. יש לפנות לשירות לקוחות",
  }

  const handlePressKey = (e) => {
    if (e.key === 'Enter') {
      handleSendMail();
    }
  }



  if (isNewspaper) {
    return <PremiumPaywallSigninEmailNewspaper {...props} handleSendMail={handleSendMail} handleMailChange={handleMailChange} isMobile contactUrl={contactUrl}  />
  } else {

    return (
      <div className="premium-paywall-mobile-signin-email">
        <h1 className="title">כניסה</h1>
        <div className={`email-signin ${authError && authError === PaywallAuthErrorCodes.INVALID_EMAIL ? 'error' : ''}`}>
          <input onKeyDown={handlePressKey} value={email} onChange={handleMailChange} type="email" placeholder="הקלידו כתובת מייל" />
          {email && <div className="reset-icon" onClick={() => setEmail('')}></div>}
          <p className="error-text">{errorMessagesFront[authError] || errorMessagesServer[authError]}</p>
        </div>
        {/* {authError && <p className="error-text" dangerouslySetInnerHTML={{ __html: errorMessagesServer[authError] || errorMessagesServer[authError] }}></p>} */}

        <div className="separator">או היכנסו באמצעות</div>

        <div className="social-signin">
          <button className="social-button google-btn" onClick={loginWithGoogle}><span>גוגל</span></button>
          <button className="social-button apple-btn" onClick={loginWithApple}><span>אפל</span></button>
        </div>
        <div className="buttons-container">
          <button className="button-base continue" disabled={!email.length} onClick={handleSendMail}>המשך</button>
        </div>

        <div className="signup">
          <div>לא מנויים? <a href="#" onClick={() => setMode({ mode: 'signUp' })}>לרכישת מנוי</a></div>
        </div>

        <div className="newspaper-users" >
          <div><span>מנויים לעיתון</span> <span className="yedioth-label"></span></div>
          <div onClick={() => setMode({ mode: 'signIn', isNewspaper: true })} className="newspaper-register-text">צרו חשבון ל-<div className="yedioth-plus-label"></div>ללא עלות</div>
        </div>
      </div>
    )
  }
}
